import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function CrearImpuesto({
  onClose = () => {},
  onCreated = () => {},
  embedded = false, 
}) {
  // --- FUNCIÓN AUXILIAR PARA OBTENER FECHA DE HOY (YYYY-MM-DD) ---
  const getToday = () => {
    return new Date().toLocaleDateString('en-CA');
  };

  // --- ESTADOS DE CAMPOS ---
  const [numero, setNumero] = useState("");
  const [data, setData] = useState(getToday());
  const [dataFechaini, setDataFechaini] = useState(getToday());
  const [dataFechafin, setDataFechafin] = useState(getToday());
  const [dataIngreso, setDataIngreso] = useState(getToday());

  // --- LÓGICA DE VALIDACIÓN ---
  const isValid = numero.trim() !== "";

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Cerrar con ESC (Solo si no es embedded)
  useEffect(() => {
    if (embedded) return; 
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, embedded]);

  // Función Guardar
  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);
    setError("");

    try {
      const payload = {
        numero: numero.trim(),
        data: data || null,
        dataFechaini: dataFechaini || null,
        dataFechafin: dataFechafin || null,
        dataIngreso: dataIngreso || null,
      };

      const created = await appFetchJson(apiRoutes.certificados.create, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      onCreated(created);
      onClose();
    } catch (e) {
      console.error("Error creando certificado:", e);
      setError(e?.message || "Ocurrió un error al guardar el certificado.");
    } finally {
      setSaving(false);
    }
  };

  // === RENDERIZADO ===
  
  // Extraemos el contenido interno del formulario para reutilizarlo
  const content = (
    <>
      {/* HEADER: Solo si NO es embedded */}
      {!embedded && (
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Certificado</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
      )}

      {/* BODY */}
      <div className={embedded ? "" : "modal-body"}>
        {!embedded && (
          <p className="text-gray-600 mb-4 italic">
            Introduzca los datos del nuevo Certificado
          </p>
        )}

        {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}

        {/* CAMBIO: Usamos flex-col para lista vertical y gap para separación */}
        <div className="flex flex-col gap-4">
          
          {/* 1. Fecha Ingreso al Sistema */}
          <div className="w-full">
            <label className="form-label">Fecha Ingreso al Sistema:</label>
            <input
              type="date"
              className="input w-full bg-gray-200 text-gray-700 cursor-not-allowed"
              value={dataIngreso}
              readOnly 
            />
          </div>

          {/* 2. Nro. Certificado */}
          <div className="w-full">
            <label className="form-label">Nro. Certificado:</label>
            <input
              type="text"
              className="input w-full"
              value={numero}
              onChange={(e) => setNumero(e.target.value)}
              placeholder="Ej: CERT-2025-001"
              autoFocus
            />
          </div>

          {/* 3. Fecha del Certificado */}
          <div className="w-full">
            <label className="form-label">Fecha del Certificado:</label>
            <input
              type="date"
              className="input w-full"
              value={data}
              onChange={(e) => setData(e.target.value)}
            />
          </div>

          {/* 4. Fecha Inicio Vigencia */}
          <div className="w-full">
            <label className="form-label">Fecha Inicio Vigencia:</label>
            <input
              type="date"
              className="input w-full"
              value={dataFechaini}
              onChange={(e) => setDataFechaini(e.target.value)}
            />
          </div>

          {/* 5. Fecha Fin Vigencia */}
          <div className="w-full">
            <label className="form-label">Fecha Fin Vigencia:</label>
            <input
              type="date"
              className="input w-full"
              value={dataFechafin}
              onChange={(e) => setDataFechafin(e.target.value)}
            />
          </div>

        </div>
      </div>

      {/* FOOTER */}
      <div className={embedded ? "mt-6" : "modal-footer"}>
        <div className="btn-row">
          <BtnGuardar
            label="Crear certificado"
            isValid={isValid}
            saving={saving}
            onClick={guardar}
          />
          {/* En modo embedded no mostramos cancelar */}
          {!embedded && <BtnCancelar onClick={onClose} />}
        </div>
      </div>
    </>
  );

  // CASO 1: SI ES EMBEDDED (Dentro del Wizard)
  if (embedded) {
    return <div className="bg-white p-1">{content}</div>;
  }

  // CASO 2: SI NO ES EMBEDDED (Modal Normal)
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
        {content}
      </div>
    </div>
  );
}